export const LineLengthList = [3, 2]
